import React from 'react';

import { TextStyleKit } from '@tiptap/extension-text-style';
import StarterKit from '@tiptap/starter-kit';
import { renderToReactElement } from '@tiptap/static-renderer';

import type { RecursiveValue } from '../interfaces';
import AnalyticsWrapper from './AnalyticsWrapper';

const RenderTiptapContent = ({
  config,
  contentBlock,
}: {
  config: Record<string, RecursiveValue>;
  contentBlock: Record<string, RecursiveValue>;
}) => {
  return (
    <AnalyticsWrapper
      shouldTrackClick={config?.should_track_click as boolean}
      shouldTrackImpression={config?.impression_tracking as boolean}
      trackingLocation={config?.analytics_location as string}
    >
      {renderToReactElement({
        content: contentBlock,
        extensions: [StarterKit, TextStyleKit],
        options: {
          unhandledNode: ({ node }) => {
            return `[unknown node ${node.type.name}]`;
          },
          unhandledMark: ({ mark }) => {
            return `[unknown node ${mark.type.name}]`;
          },
        },
      })}
    </AnalyticsWrapper>
  );
};

export default RenderTiptapContent;
